<template>
    <HeadingContainer :addPaddingBottom="false" heading="Account Settings">
            <div class="col-xs-12">
                <NameCard height="90" :user="user" class="mt3"/>
                <SettingsList class="mt3"/>
            </div>
            
    </HeadingContainer>
</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import NameCard from '@/components/accountSettings/NameCard.vue';
import SettingsList from '@/components/accountSettings/settingsMenu/SettingsMenu.vue';
import { mapState } from 'vuex';

export default {
    components: {
        HeadingContainer,
        NameCard,
        SettingsList
    },
    computed: {
        ...mapState('users', ['user'])
    }
};
</script>
